/* eslint-disable no-unused-vars */
import C from "../../constants/assistantsConfig";
import axios from "axios";
import i18n from "i18next";
import lod_ from "lodash";
import store from "../store.js";
import { errorMsg } from "redux/reducers/snackMsgsReducers.js";
import { traceError } from "helpers/utilities.js";
import { redirectCockpitUrlIfNeeded } from "../../helpers/redirectCockpitUrl";

const endPoint = process.env.REACT_APP_AMBACK;

/**
 * FBDB-4753 : la configuration est assemblée part par part côté auth-dev. Une seule part
 * en échec fait tomber tout l'appel, et le cockpit restait alors avec une config vide
 * sans que ni l'agent ni le back n'en soient informés (catch vide). On réessaye donc une
 * fois, puis on trace et on prévient l'agent.
 */
const MAX_CONFIG_ATTEMPTS = 2;
const RETRY_DELAY_MS = 1500;

/**
 * Appelle une fois /assistantConfig
 * @param {object} data - Corps de la requête (email, assistantID, parts)
 * @param {object} headers - En-têtes d'authentification
 * @returns {Promise<{success: boolean, result?: object, message?: string}>}
 */
const fetchAssistantConfig = async (data, headers) => {
	try {
		const result = await axios.post(endPoint + "/api/v1/assistantConfig", data, {
			headers: headers
		});

		if (lod_.isNil(result?.data) || lod_.isEmpty(result.data)) {
			return {
				success: false,
				message: `assistantConfig returned no data for ${data.assistantID}`
			};
		}

		return { success: true, result: result };
	} catch (error) {
		return {
			success: false,
			message: `assistantConfig failed for ${data.assistantID}: ${error.message}`
		};
	}
};

/**
 * Attente entre deux tentatives
 * @param {number} delay - Durée en millisecondes
 * @returns {Promise<void>}
 */
const wait = async delay => {
	await new Promise(resolve => setTimeout(resolve, delay));
};

const actions = {
	getConfigByAssistant: function (assistantID) {
		let user = store.getState().userStatus.auth.user;
		let parts = [
			"account",
			"actions",
			"APIs",
			"bot",
			"channels",
			"cockpit",
			"COLD",
			"dictionary",
			"general",
			"intents",
			"languages"
			// "limit", ** KEVIN 10/03/2025 comment this to not get this attribute because not use in cockpit now all in assistantConfig.cockpit ***
		];
		if (user) {
			return async dispatch => {
				const headers = {
					"Content-Type": "application/json",
					Authorization: `Bearer ${user.token}`,
					UserEmail: user.email
				};
				const data = {
					email: user.email,
					assistantID: assistantID,
					parts: parts
				};

				let lastMessage = "";

				for (let attempt = 1; attempt <= MAX_CONFIG_ATTEMPTS; attempt++) {
					const config = await fetchAssistantConfig(data, headers);

					if (config.success) {
						// TODO : PIKA -> Why doing so, it'll computed anyhow by the back
						// dispatch({
						// 	type: "ws/set_human_request",
						// 	payload: true
						// });
						redirectCockpitUrlIfNeeded(config.result);
						dispatch({
							type: C.GET_CONFIG,
							payload: config.result.data
						});
						return;
					}

					lastMessage = config.message;

					if (attempt < MAX_CONFIG_ATTEMPTS) {
						await wait(RETRY_DELAY_MS);
					}
				}

				// Toutes les tentatives ont échoué : le cockpit tourne sans configuration,
				// il faut que l'agent et le back le sachent.
				traceError(`getConfigByAssistant-${MAX_CONFIG_ATTEMPTS} attempts failed: ${lastMessage}`);
				dispatch(errorMsg(i18n.t("COC.errorLoadingAssistantConfig")));
			};
		}
	}
};

export default actions;
